import { PaymentOffsetInterface } from "../PaymentOffsetInterface";
import { PaymentOffset } from "../PaymentOffset";
import Translator from "../../../../../Translation/Translator";

class WeekAfter extends PaymentOffset implements PaymentOffsetInterface  {

  public static value: number = 7;

  public getName(): string {
    return Translator.trans("payment-offset-week-after");
  }

}

export { WeekAfter }
